import { useSortable } from '@dnd-kit/react/sortable';
import type { ReportField } from '../../hooks/useReports';

/**
 * One draggable row in the resource-report field customizer: drag handle + the
 * (read-only) field name, an enable checkbox, and an editable output name. Mirrors
 * dialog_report.html's sortable field list. `hidden` keeps the row mounted (so drag
 * indices stay stable) while the filter box hides non-matching rows.
 */
export function ReportFieldRow({
  field,
  index,
  hidden,
  onChange,
}: {
  field: ReportField;
  index: number;
  hidden: boolean;
  onChange: (f: ReportField) => void;
}) {
  const { ref, isDragging } = useSortable({ id: field.name, index });

  return (
    <li ref={ref} style={{ opacity: isDragging ? 0.4 : 1, display: hidden ? 'none' : undefined, marginBottom: 6 }}>
      <div className="row">
        <div className="col-sm-6">
          <div className="input-group">
            <span className="input-group-addon iio-drag-handle" style={{ cursor: 'move' }}>
              <i className="fas fa-sort" />
            </span>
            <input type="text" className="form-control uneditable-input" value={field.name} disabled readOnly />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="input-group">
            <span className="input-group-addon">
              <input
                type="checkbox"
                checked={field.isEnabled}
                aria-label={`Include ${field.name}`}
                onChange={(e) => onChange({ ...field, isEnabled: e.target.checked })}
              />
            </span>
            <input
              type="text"
              className="form-control"
              value={field.outputName}
              onChange={(e) => onChange({ ...field, outputName: e.target.value })}
            />
          </div>
        </div>
      </div>
    </li>
  );
}
